import React, {useEffect, useRef, useState} from 'react'
import {getRecipeById} from "../../../services/serviceRecipe";
import {useParams} from "@reach/router";
import {Button, Col, Row, Tooltip} from "antd";
import RecipeDetailedItems from "./RecipeDetailedItems";
import {useReactToPrint} from "react-to-print";


const RecipeDetailedList = ({recipeIdentity}) => {
    const {recipeId} = useParams()
    const [recipe, setRecipe] = useState({})
    const [loadData, setLoadData] = useState(false)

    useEffect(() => {
        getRecipeById(recipeIdentity ? recipeIdentity : recipeId)
            .then(({data}) => {
                setRecipe(data)
                setLoadData(!loadData)
            })
    }, [])

    const componentPrint = useRef();
    const handlePrint = useReactToPrint({
        content: () => componentPrint.current,
    });


    return (
        <React.Fragment>
            {
                loadData ?
                    <div>
                        <Row justify={'end'}>
                            <Col>
                                <Tooltip title={'Yazdırma işleminden önce menüyü kapatınız'}>
                                    <Button
                                        onClick={() => handlePrint()}
                                        type={'primary'}
                                    >
                                        Yazdır
                                    </Button>
                                </Tooltip>
                            </Col>
                        </Row>
                        <RecipeDetailedItems ref={componentPrint} recipe={recipe} />
                    </div>
                    : null
            }
        </React.Fragment>
    )
}
export default RecipeDetailedList